import { render, staticRenderFns } from "./PublishingStatementsJournalDialog.vue?vue&type=template&id=82433cfc"
import script from "./PublishingStatementsJournalDialog.vue?vue&type=script&lang=js"
export * from "./PublishingStatementsJournalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports